export default __webpack_public_path__ + "4eed12581f059d6d86961bb3eb47a090.svg";